import React, { useRef, useEffect } from "react";

// Scss imports
import css from "./InputField.module.scss";

interface InputFieldProps {
  label: string;
  id: string;
  type: string;
  name: string;
  placeholder?: string;
  value?: any;
  handleChange?: any;
  handleOnFocus?: any;
  handleOnBlur?: any;
  errorText?: string;
  minLength?: boolean;
  maxLength?: boolean;
  title?: boolean;
  refInput?: any;
  setEmail?: any;
  onInputHandler?: any;
  rowFormGroup?: boolean;
  minLabelWidth?: boolean;
  disabled?: boolean;
  buttonType?: string;
  inputType?: string;
  suggestions?: string[] | undefined;
  recipientValue?: string;
  setRecipientValue?: any;
  users?: any;
  nationalIdValue?: string;
  errorTextColumn?: string;
  readOnly?: boolean;
  labelClass?: string;
  rowFormGroupCenter?: boolean;
  setNationalIdValue?: any;
  setSuggestions?: Function | undefined;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  id,
  type,
  name,
  placeholder,
  value,
  handleChange,
  handleOnFocus,
  handleOnBlur,
  errorText,
  onInputHandler,
  rowFormGroup,
  minLabelWidth,
  disabled,
  inputType,
  suggestions,
  recipientValue,
  setRecipientValue,
  users,
  setNationalIdValue,
  errorTextColumn,
  readOnly,
  labelClass,
  rowFormGroupCenter,
  setSuggestions,
}) => {
  // Reference to suggestions div
  const suggestionsDivRef: any = useRef();
  const suggestionsRef: any = useRef();

  // Function for read value of paragraph on onClick
  const readValue = (e) => {
    let text = e.target.textContent;
    setRecipientValue(text);

    let filteredUsers = users.find(
      (user) => user.name1 === e.target.textContent
    );

    if (inputType === "autosuggestionRecipient") {
      setNationalIdValue(filteredUsers.nationalId);
    }

    if (setSuggestions) {
      setSuggestions([]);
    }
  };

  return (
    <div
      className={`${inputType === "filterInput" ? css.filterInput : null} ${
        css.formGroup
      } ${rowFormGroupCenter ? css.rowFormGroupCenter : ""} ${
        rowFormGroup ? css.rowFormGroup : null
      }`}
    >
      <label
        className={`${labelClass === "marginLabel" ? css.labelMargin : ""} ${
          minLabelWidth ? css.minLabelWidth : ""
        } ${rowFormGroup ? css.rowLabel : null} ${
          inputType === "category" ? css.categoryLabel : ""
        }`}
        htmlFor={id}
      >
        {label}
      </label>
      {errorText !== "" && (
        <p
          className={`${css.errorText} ${
            inputType === "filter" || inputType === "filterInput"
              ? css.filter
              : ""
          } `}
        >
          {errorText}
        </p>
      )}
      <div
        className={`${css.inputAutosuggestion} ${
          rowFormGroupCenter ? css.inputAutosuggestionCenter : ""
        }`}
      >
        <input
          name={name}
          id={id}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          onInput={onInputHandler}
          readOnly={readOnly}
          className={`${inputType === "filterInput" ? css.filterInput : null} ${
            rowFormGroup ? css.rowInput : null
          } ${errorTextColumn ? css.errorInput : ""} ${
            inputType === "category" ? css.categoryInput : ""
          }`}
          disabled={disabled}
        />
        {errorTextColumn !== "" && (
          <p
            className={`${css.errorText} ${
              inputType === "category" ? css.categoryErrorText : ""
            } ${inputType === "processor" ? css.processorErrorText : ""}`}
          >
            {errorTextColumn}
          </p>
        )}
        {(inputType === "autosuggestionRecipient" ||
          inputType === "autosuggestionProccesor") &&
          suggestions !== undefined && (
            <div
              className={`${
                suggestionsDivRef.innerText !== ""
                  ? css.suggestionsContainer
                  : null
              }`}
              ref={suggestionsRef}
            >
              {suggestions.map((item, index) => {
                return (
                  <div onClick={(e) => readValue(e)} key={index + item}>
                    <p ref={suggestionsDivRef}>{item}</p>
                  </div>
                );
              })}
            </div>
          )}
      </div>
    </div>
  );
};

export default InputField;
